export default [
  { city: 'PERUGIA',                  phone: '3807560879', slug: '' },
  { city: 'TRANI',                    phone: '3281144176', slug: '' },
  { city: 'GRAVINA IN PUGLIA',        phone: '3278791139', slug: '' },
  { city: 'MAGLIE',                   phone: '3281668224', slug: '' },
  { city: 'ROMA',                     phone: '3898207959', slug: '' },
  { city: 'SAN GIOVANNI ROTONDO',     phone: '3886524901', slug: '' },
  { city: 'OSTUNI',                   phone: '3889250060', slug: '' },
  { city: 'ANDRIA',                   phone: '3280720330', slug: 'andria' },
  { city: 'SAN BENEDETTO DEL TRONTO', phone: '3279952848', slug: '' },
  { city: 'BARI',                     phone: '3891844456', slug: '' },
]